import styled from 'styled-components';

export const TelefonesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const BarraTopo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const TituloBloco = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  color: #718096;
`;

// Sem rolagem propria: a aba inteira ja rola, dois scrolls aninhados
// atrapalhariam quem esta percorrendo a lista.
export const ListaTelefones = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TelefoneLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid ${(props) => (props.$ativo ? '#2670d1' : '#e2e8f0')};
  background: ${(props) => (props.$ativo ? '#ebf8ff' : '#ffffff')};
  cursor: ${(props) => (props.$clicavel ? 'pointer' : 'default')};
  transition: 0.2s;

  &:hover {
    border-color: ${(props) => (props.$clicavel ? '#2670d1' : '#e2e8f0')};
  }
`;

export const TelefoneDados = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const TelefoneNumero = styled.span`
  font-size: 14px;
  color: ${(props) => (props.$improdutivo ? '#FF3B30' : '#2d3748')};
  font-weight: ${(props) => (props.$improdutivo ? 600 : 400)};
`;

export const TelefoneMeta = styled.span`
  font-size: 11px;
  color: #718096;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TelefoneBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;

export const Badge = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 600;
  color: ${(props) => (props.$solido ? '#ffffff' : props.color)};
  background: ${(props) => (props.$solido ? props.color : 'transparent')};
  border: 1px solid ${(props) => props.color};
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
`;

export const NovoContatoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px dashed #cbd5e0;
  border-radius: 6px;
`;

export const VazioMensagem = styled.span`
  font-size: 12px;
  color: #718096;
  padding: 8px 0;
`;
